import { useQuery } from "@tanstack/react-query";

import {
  notificationsApi,
  type NotificationsFilters,
} from "@/features/engagement/services/notifications.api";

export function useNotifications(filters: NotificationsFilters, page: number) {
  return useQuery({
    queryKey: ["notifications", filters, page],
    queryFn: () => notificationsApi.getNotifications({ ...filters, page }),
  });
}
